export default __webpack_public_path__ + "static/media/default-avatar.a286f3d2.svg";